/**
 * Labstep
 *
 * @module components/EntityUser/Action/Manage/List
 * @desc   Manage collaborators
 */

import { EntityUserActionManage } from 'labstep-web/components/EntityUser/Action/Manage';
import { EntityUserList } from 'labstep-web/components/EntityUser/List';
import type React from 'react';
import type { EntityUserActionManageListProps } from './types';

export const EntityUserActionManageList: React.FC<
  EntityUserActionManageListProps
> = ({ entity, hidePopup, entityUserRoleName }) => (
  <EntityUserActionManage
    entity={entity}
    viewComponent={({ toggleModal }) => (
      <EntityUserList
        onPlusCountClick={toggleModal}
        entity={entity}
        hidePopup={hidePopup}
        entityUserRoleName={entityUserRoleName}
      />
    )}
  />
);
